<template>
  <div class="w-full relative sm:flex">
    <div class="flex-initial flex-grow">
      <slot
        :weekDates="weekDates"
        :week="week"
        :set-week="setWeek"
        :products="products"
        :orders="ordersByWeek ? ordersByWeek.data : null"
        :submit="submitOrders"
        :submitting-orders="submittingOrders"
        :error-on-submit="errorOnSubmit"
        :error-bag="errorBag"
        :loading="loading"></slot>
    </div>
  </div>
</template>

<script>
import ReceiverMixin from './ReceiverMixin'
import SenderMixin from './SenderMixin'

export default {
  name: 'OrdersProvider',
  mixins: [ ReceiverMixin, SenderMixin ],
}
</script>
